const DOCUMENT = 'SETTINGS_';

const actions = {
  INIT_DATA: DOCUMENT + 'INIT_DATA',
  INIT_DATA_COMPLETED: DOCUMENT + 'INIT_DATA_COMPLETED',
  CLEAR_SETTINGS: DOCUMENT + 'CLEAR_SETTINGS',
  CLEAR_SETTINGS_SUCCESS: DOCUMENT + 'CLEAR_SETTINGS_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  SAVE: DOCUMENT + 'SAVE',
  CANCEL: DOCUMENT + 'CANCEL',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',

  initData: () => {
    return {
      type: actions.INIT_DATA,
    };
  },

  edit: () => {
    return {
      type: actions.EDIT,
    };
  },

  cancel: () => {
    return {
      type: actions.CANCEL,
    };
  },

  clearSettings: data => {
    return {
      type: actions.CLEAR_SETTINGS,
      payload: data,
    };
  },

  clearSettingsSuccess: data => {
    return {
      type: actions.CLEAR_SETTINGS_SUCCESS,
      payload: data,
    };
  },

  initDataCompleted: data => ({
    type: actions.INIT_DATA_COMPLETED,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),
};

export default actions;
